import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Snackbar } from 'rmwc/Snackbar';
import { Typography } from 'rmwc/Typography';
import { Select } from 'rmwc/Select';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';
import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'
import { FormField } from 'rmwc/FormField';
import { ListDivider } from 'rmwc/List';
import {default as Reactsel} from 'react-select';
import ResourceComponent from '../learning_resource_admin/ResourceComponent';

class TrackBasedResource extends Component {
	constructor(props) {
    	super(props)
    	this.state = {
    		selectedTrack: '',
    		fetchData:{
    			trackDropDown: []
    		},
    		data:{
    			userResourceDetails: [],
    			adminResourceDetails: []
    		}
    	}
    }

    handleTrackSelect = (option) => {
        this.setState(state => {
            return {
               selectedTrack : option
            };
        });
    }

    handleResourceFetch = (e) => {
    	let data = Object.assign({}, this.state.data)
    	let resourceFetch = `learning_resource/tracks/render_resources/${this.state.selectedTrack.value}`

    	api.getResponse(this.props.user.accessToken, resourceFetch)
    	.then((result) => {
    		if (result.status === 'success') {
    			if (this.props.userType === 'admin') {
    				data.adminResourceDetails = result.data
    			}
    			else if (this.props.userType === 'user'){
    				data.userResourceDetails = result.data	
    			}
    			this.setState({data: data})
    		}
    	})
    }

	componentDidMount() {
		let fetchData = Object.assign({}, this.state.fetchData)
		let fetchTracks = 'user/learning_resource/search_tracks'

		return api.getUserResponse(this.props.user.accessToken, fetchTracks)
        .then((result) => {
	    	if (result.status === 'success') {
	        	fetchData.trackDropDown = result.data
				this.setState({fetchData: fetchData})
			}
		})
	} 
	
	handleDummyFetch = (e) => {
	}

	render(){
		let handleResourceFetch = this.handleResourceFetch
		let handleDummyFetch = this.handleDummyFetch
		let individualResource
		let trackValue = this.state.selectedTrack.value

		if (this.props.userType === 'user') {
			if (this.state.data.userResourceDetails.length > 0) {
	            individualResource = (
	                <Grid className="opportunity-list-item">
	                    {this.state.data.userResourceDetails.map(function(resource){
	                    	let uniq = Math.random() * resource.id * trackValue
	                        return (
	                            <GridCell span = "12" key = {uniq}>
	                                <Card style={{padding: '0px'}}>
	                                    <ResourceComponent resourceId = {resource.id}
	                                        resourceName = {resource.name}
                                            resourceAuthor = {resource.author}
                                            resourceDescription = {resource.description}
                                            shortDescription = {resource.short_description}
                                            resourceLink = {resource.resource_link}
                                            resourceLanguage = {resource.language}
                                            languageId = {resource.language_id}
                                            resourceComplexity = {resource.complexity}
                                            complexityId = {resource.complexity_id}
                                            parentTags = {resource.parent_tags}
                                            resourceStatus = {resource.active}
                                            resourceType = {resource.resource_type}
                                            onHandleResourceFetch = {handleDummyFetch}
                                            isAdmin = {false}
                                            bookmarkFeature = {true} 
                                            archiveFeature = {false}
	                                    />
	                                </Card>
	                            </GridCell>
	                        )
	                    })}
	                </Grid>
	            )
	        }
	        else {
	        	individualResource = (
	        		<Grid className="opportunity-list-item">
	                    <GridCell span = "12">
	                        <Card style={{padding: '25px'}}>
	                            <Typography> There are currently no resources to display.</Typography>
	                        </Card>
	                    </GridCell>
	                </Grid>
	        	)
	        }
	    }

		let resourceFetchForm = (
			<Grid style={{padding: '0px'}}>
                <GridCell span = "6">
                    <Reactsel
                        name="buzzwordlist"
                        onChange={this.handleTrackSelect}
                        value={this.state.selectedTrack}
                        options={this.state.fetchData.trackDropDown}
                        placeholder="--Enter or Select Subject--">
                    </Reactsel>
                </GridCell>
                <GridCell span = "4">
                    <Button raised style={{ width: '50%' }} onClick= {((e) => handleResourceFetch(e))}>Search</Button>
                </GridCell>
            </Grid>
		)
		return (
			<div>
				<Grid>
					<GridCell span = "10">
						{resourceFetchForm}
					</GridCell>
				</Grid>
				{individualResource}
			</div>
		)
	}
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(TrackBasedResource);


// WEBPACK FOOTER //
// ./src/views/learning_resource_user/TrackBasedResource.jsx